var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-img',{attrs:{"alt":_vm.alt,"src":_vm.imagePreview(_vm.src),"contain":"","max-height":"200"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }